import { registerLocaleData } from "@angular/common";
import localeEn from "@angular/common/locales/en";
import localeFr from "@angular/common/locales/fr";
import { Component, OnInit } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { NavigationService } from "./navigation/navigation.service";
import { I18nService } from "./providers/i18n.service";
import { AppService } from "./store/app.service";

@Component({
    selector: "nerri-app",
    standalone: false,
    templateUrl: "./app.component.html",
    styleUrls: ["./app.style.scss"]
})
export class AppComponent implements OnInit {
    constructor(
        private appService: AppService,
        private navigationService: NavigationService,
        private i18nService: I18nService,
        private translateService: TranslateService,
        private matIconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer
    ) {
        this.matIconRegistry.setDefaultFontSetClass("material-icons-outlined");
        this.matIconRegistry.addSvgIconSetInNamespace(
            "streamline-bold",
            this.sanitizer.bypassSecurityTrustResourceUrl("assets/icons/bold-icons.svg")
        );
        this.matIconRegistry.addSvgIconSetInNamespace(
            "streamline-regular",
            this.sanitizer.bypassSecurityTrustResourceUrl("assets/icons/regular-icons.svg")
        );
        this.matIconRegistry.addSvgIconSetInNamespace(
            "heroicons_outline",
            this.sanitizer.bypassSecurityTrustResourceUrl("assets/icons/heroicons-outline.svg")
        );
        this.matIconRegistry.addSvgIconSetInNamespace(
            "heroicons_solid",
            this.sanitizer.bypassSecurityTrustResourceUrl("assets/icons/heroicons-solid.svg")
        );
    }

    public async ngOnInit(): Promise<void> {
        this.appService.init().subscribe();
        this.appService.loadServerState().subscribe();
        await this.navigationService.init();

        const lang = this.i18nService.getDefaultLang();
        localStorage.setItem("lang", lang);
        this.updateLang(lang);
    }

    private updateLang(lang: string): void {
        this.translateService.setDefaultLang(lang);
        registerLocaleData(localeFr);
        registerLocaleData(localeEn);
    }
}
